import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-4 pt-2" }
const _hoisted_2 = { class: "flex flex-column gap-3 pl-4 text-base" }
const _hoisted_3 = {
  key: 0,
  class: "mt-6 flex gap-3 align-items-start"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check border-1 border-circle border-dashed border-primary text-primary text-center p-2 text-xl" }, null, -1)
const _hoisted_5 = { class: "flex flex-column" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "text-base" }
const _hoisted_8 = {
  key: 1,
  class: "mt-6 flex gap-3 align-items-start"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_x border-1 border-circle border-dashed border-red-500 text-red-500 text-center p-2 text-xl" }, null, -1)
const _hoisted_10 = { class: "flex flex-column" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "text-base" }
const _hoisted_13 = {
  key: 2,
  class: "mt-6 p-3 py-4 bg-gray-200"
}
const _hoisted_14 = { class: "flex flex-column gap-2 text-base" }
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "mt-4 flex flex-column gap-2 text-base" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = { class: "flex gap-1" }
const _hoisted_19 = { class: "mt-4 flex flex-column gap-2 text-base" }
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = { class: "mt-2 flex flex-column text-base" }
const _hoisted_22 = { class: "font-bold" }
const _hoisted_23 = { class: "mt-2 flex flex-column text-base" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "mt-2 flex flex-column text-base" }
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = { class: "mt-2 flex flex-column text-base" }
const _hoisted_28 = { class: "font-bold" }
const _hoisted_29 = { class: "mt-2 flex flex-column text-base" }
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = { class: "mt-4 flex flex-column gap-2 text-base" }
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = {
  key: 3,
  class: "mt-6"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-L" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("waste_take_away.note_3")), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("waste_take_away.note_4")), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("waste_take_away.note_5")), 1),
      _createElementVNode("li", null, _toDisplayString(_ctx.$t("waste_take_away.note_6")), 1)
    ]),
    (_ctx.successful)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("waste_take_away.success_title")) + " " + _toDisplayString(_ctx.$moment(new Date()).format("DD.MM.YYYY")) + "! ", 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("waste_take_away.success_description")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("waste_take_away.error_title")), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("waste_take_away.error_description")), 1)
          ])
        ])),
    (_ctx.successful)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("waste_take_away.client_number")), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.order.client_number ? _ctx.order.client_number : "/"), 1)
          ]),
          _createVNode(_component_Divider),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("waste_take_away.waste_quantity")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredWasteTypeQuantity, (count, type) => {
              return (_openBlock(), _createElementBlock("span", { key: type }, [
                _createElementVNode("span", _hoisted_18, [
                  _createElementVNode("strong", null, _toDisplayString(count) + "x", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`waste_take_away_types.${type}`)), 1)
                ])
              ]))
            }), 128))
          ]),
          _createVNode(_component_Divider),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("waste_take_away.personal_data")), 1),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("waste_take_away.client_name")) + ":", 1),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.order.client_name), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("waste_take_away.address")) + ":", 1),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.order.address), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("waste_take_away.personal_id_number")) + ":", 1),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.order.personal_id_number ? _ctx.order.personal_id_number : "/"), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("waste_take_away.phone")) + ":", 1),
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.order.phone_number), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("waste_take_away.mail")) + ":", 1),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.order.email ? _ctx.order.email : "/"), 1)
            ])
          ]),
          _createVNode(_component_Divider),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("waste_take_away.notes_title")), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.order.notes ? _ctx.order.notes : "/"), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.successful)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("button", {
            class: "flex gap-3 border-none bg-white text-primary text-lg cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
          }, [
            _hoisted_34,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("waste_take_away.edit_order")), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}